import { OperatorTypeDetails, OperatorTypes } from '@avtechsoftware/ra-javascript-utilities/src/types/OperatorTypes';
import BaseFacet from '../BaseFacet/BaseFacet';
import FacetType from '../../../utility/types/facetType';
import { facetTypeDetails } from '../../../utility/types/facetTypeDetails';

class AlertThresholdFacet extends BaseFacet {
  constructor() {
    super();
    this.facetType = FacetType.THRESHOLD;
    this.displayName = 'Alert Thresholds';
    this.description = 'include...';
  }

  // eslint-disable-next-line class-methods-use-this
  getOperatorDescription(operatorType) {
    const operatorDescriptions = {
      [OperatorTypes.GREATER_THAN]: OperatorTypeDetails[OperatorTypes.GREATER_THAN].label,
      [OperatorTypes.LESS_THAN]: OperatorTypeDetails[OperatorTypes.LESS_THAN].label,
      [OperatorTypes.EQUAL_TO_VALUE]: 'ANY of the following:',
    };
    return operatorDescriptions[operatorType] || '';
  }

  getOperatorSelectOptions() {
    const facet = facetTypeDetails[this.facetType];
    return [
      {
        value: facet.validOperators[0],
        label: this.getOperatorDescription(facet.validOperators[0]),
      },
      {
        value: facet.validOperators[1],
        label: this.getOperatorDescription(facet.validOperators[1]),
      },
      {
        value: facet.validOperators[2],
        label: this.getOperatorDescription(facet.validOperators[2]),
      },
    ];
  }

  // eslint-disable-next-line class-methods-use-this
  // getTooltip(filtersByOperatorObj) {
  //   return `Thresholds ${
  //     filtersByOperatorObj[OperatorTypes.CONTAINS]
  //       ? `Include ${filtersByOperatorObj[OperatorTypes.CONTAINS]
  //         .map((filter) => filter.value1).join(', ')
  //       };`
  //       : ''
  //   }${
  //     filtersByOperatorObj[OperatorTypes.NOT_CONTAIN]
  //       ? ` NONE of ${filtersByOperatorObj[OperatorTypes.NOT_CONTAIN]
  //         .map((filter) => filter.value1).join(', ')
  //       };`
  //       : ''
  //   }`;
  // }
}
export default AlertThresholdFacet;
